export default __webpack_public_path__ + "img/cloud-vmware.fbcdf09.svg";